import { ROLES, ROLE_ROUTES } from "../config/roles";

export const getNavigation = (
  role,
  profileData = null,
  kycVerified = true,
  userPermissions = []
) => {
  console.log("Navigation - Current Role:", role);
  console.log("Navigation - Profile Data:", profileData);
  console.log("Navigation - KYC Verified:", kycVerified);
  console.log("Navigation - User Permissions:", userPermissions);

  // Helper function to check if user has permission
  const hasPermission = (permission) => {
    return (
      Array.isArray(userPermissions) && userPermissions.includes(permission)
    );
  };

  const baseNav = [];

  // Build navigation items based on role and permissions
  const buildRoleNav = () => {
    const navItems = [];

    switch (role) {
      case ROLES.ClubAdmin:
        navItems.push({
          label: "Requests",
          path: ROLE_ROUTES[ROLES.ClubAdmin].tenders,
        });

        navItems.push({
          label: "My Club",
          path: ROLE_ROUTES[ROLES.ClubAdmin].dashboard,
        });
        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      case ROLES.Agent:
        navItems.push({
          label: "Requests",
          path: ROLE_ROUTES[ROLES.Agent].tenders,
        });

        navItems.push({
          label: "My Players",
          path: ROLE_ROUTES[ROLES.Agent].dashboard,
        });
        // Agent perspective: "Agent Requests" AND "Taskboard" live in the ☰
        // menu, not the top bar — see the submenuItems in
        // hooks/header/useHeaderNavigation.js.
        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      case ROLES.AgencyAdmin:
        navItems.push({ label: "My agency", path: "/agency" });
        navItems.push({ label: "Agency pitches", path: "/agency/pitches" });
        // Agency perspective (Marin, Runde 6): "Taskboard" is TOP-LEVEL here;
        // only "Agent Requests" goes into the ☰ menu (see useHeaderNavigation).
        navItems.push({ label: "Taskboard", path: "/agency/taskboard" });
        break;

      case ROLES.Staff:
        // Requests is shown regardless of `view_tenders` (Marin, 2026-08-07,
        // QAF01-044 variant a): the job board must stay reachable even for club
        // members whose role lost the permission. The backend already builds
        // exactly that reduced view for them — decree D23 in dashboard/views.py
        // serves the "viewer WITHOUT view_tenders" staff requests plus their own,
        // and no foreign player requests. The wall is untouched; only the way in
        // was missing. Route /staff/tenders is role-gated only (routes/index.js
        // :982-989 — allowedRoles, no requiredPermission), so the link resolves.
        navItems.push({
          label: "Requests",
          path: ROLE_ROUTES[ROLES.Staff].tenders,
        });

        if (hasPermission("edit_squad") || hasPermission("invite_new_staff")) {
          navItems.push({
            label: "My Club",
            path: ROLE_ROUTES[ROLES.Staff].dashboard,
          });
        }

        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      case ROLES.Coach:
        // Same as the Staff case above (QAF01-044 variant a): the D23 job board
        // stays reachable without `view_tenders`. /coach/tenders is role-gated
        // only (routes/index.js:1023-1030 — allowedRoles, no requiredPermission).
        navItems.push({
          label: "Requests",
          path: ROLE_ROUTES[ROLES.Coach].tenders,
        });

        if (hasPermission("edit_squad") || hasPermission("invite_new_staff")) {
          navItems.push({
            label: "My Club",
            path: ROLE_ROUTES[ROLES.Coach].dashboard,
          });
        }

        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      case ROLES.Player:
        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      case ROLES.Organizer:
        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      // Lawyer-only users are chat-first: they must reach the Inbox to read the
      // chats that agents/clubs start with them. Additive — no other role's nav
      // is affected. The "Lawyer profile" settings link lives in the profile
      // dropdown (role-gated), and the Lawyers directory is in the Discover
      // submenu. "Requests" is the staff-only tender feed (D-011): a lawyer can
      // browse and apply to STAFF requests only (backend-scoped). Dual-role
      // users act under their Agent role for the richer agent Requests, so this
      // lawyer case only fires for lawyer-only users — no duplicate item.
      case ROLES.Lawyer:
        navItems.push({
          label: "Requests",
          path: ROLE_ROUTES[ROLES.Lawyer].tenders,
        });
        navItems.push({ label: "Inbox", path: "/inbox" });
        break;

      default:
        break;
    }

    return navItems;
  };

  let finalNav = [];
  const roleNavItems = buildRoleNav();

  if (role === ROLES.Player) {
    finalNav = [...roleNavItems];
  } else {
    finalNav = [...baseNav, ...roleNavItems];
  }

  // If user is not KYC verified, only show home navigation
  if (!kycVerified) {
    finalNav = [{ label: "Home", path: "/" }];
  }

  console.log("Navigation - Final Nav Items:", finalNav);
  return finalNav;
};
